<template>
  <div class="layout-wrap">
    <div class="layout-top">
      <main>
        <div class="logo-wrap">
          <img src="../static/images/top-logo.png" alt="" />
        </div>
        <div class="search-wrap">
          <ul class="flex search-nav">
            <li
              class=""
              v-for="item in topList"
              :key="item.id"
              :class="{ active: topId === item.id }"
              @click="topNavChange(item)"
            >
              {{ item.title }}
            </li>
          </ul>
          <el-input v-model="search" :placeholder="placeholder">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="searchHandler"
            ></el-button>
          </el-input>
        </div>
        <div class="user-wrap" v-if="nickName">
          <router-link to="/user/basic">
            <i class="el-icon-s-custom"></i>
            <span>{{ nickName }}</span> </router-link
          >/
          <span @click="logoutHandler">退出</span>
        </div>
        <div class="user-wrap" v-else>
          <router-link to="/login">登录</router-link>
          <span>/</span>
          <router-link to="/register">注册</router-link>
        </div>
      </main>
    </div>

    <div class="layout-nav">
      <main class="flex flex-wrap flex-row-center">
        <router-link
          class="nav-link"
          tag="a"
          v-for="(item, index) in navList"
          :key="index"
          :class="{
            active:
              index == 0 ? navName === 'index' : item.link.includes(navName),
          }"
          :to="item.href"
        >
          <p>{{ item.title }}</p>
        </router-link>
      </main>
    </div>

    <div class="layout-router">
      <router-view></router-view>
    </div>

    <el-backtop :visibility-height="200" :right="0" target=".layout-wrap">
      <div class="">
        <img src="@/static/images/back-top.png" alt="" srcset="" />
        <p>TOP</p>
      </div>
    </el-backtop>

    <div class="layout-fixed">
      <div class="flex flex-column-center" @click="goUserCallback">
        <img src="@/static/images/user-callback.png" alt="" srcset="" />
        <p>用户反馈</p>
      </div>
<!--      <div-->
<!--        class="flex-wechat"-->
<!--        @mouseover="qrShow = true"-->
<!--        @mouseleave="qrShow = false"-->
<!--      >-->
<!--        <div class="flex flex-column-center">-->
<!--          <img src="@/static/images/wechat.png" alt="" srcset="" />-->
<!--          <p>公众号</p>-->
<!--        </div>-->
<!--        <div class="qr-wrap flex flex-column-center" v-show="qrShow">-->
<!--          <img src="@/static/images/fixed-qr.jpg" alt="" srcset="" />-->
<!--          <p>信用中国(山东肥城)</p>-->
<!--        </div>-->
<!--      </div>-->
    </div>

<!--    <div class="layout-link">-->
<!--      <main class="flex flex-row-between">-->
<!--        <div>-->
<!--          <el-select-->
<!--            v-model="value1"-->
<!--            placeholder="成员单位链接"-->
<!--            @change="(val) => urlBlank(val, 1)"-->
<!--          >-->
<!--            <el-option-->
<!--              v-for="(item, index) in unitList"-->
<!--              :key="index"-->
<!--              :disabled="!item.link"-->
<!--              :label="item.name"-->
<!--              :value="item.code"-->
<!--            >-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
<!--        <div>-->
<!--          <el-select-->
<!--            v-model="value2"-->
<!--            placeholder="其他省市信用网"-->
<!--            @change="(val) => urlBlank(val, 2)"-->
<!--          >-->
<!--            <el-option-->
<!--              v-for="(item, index) in provinceList"-->
<!--              :key="index"-->
<!--              :disabled="!item.link"-->
<!--              :label="item.name"-->
<!--              :value="item.code"-->
<!--            >-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->

<!--        <div>-->
<!--          <el-cascader-->
<!--            @change="(val) => urlBlank(val, 3)"-->
<!--            :options="cityList"-->
<!--            :props="{ value: 'id', label: 'name', children: 'children' }"-->
<!--            placeholder="市县信用网"-->
<!--          >-->
<!--          </el-cascader>-->
<!--        </div>-->
<!--        <a-->
<!--          v-for="(item, index) in linkList"-->
<!--          :key="index"-->
<!--          :href="item.link"-->
<!--          target="_blank"-->
<!--        >-->
<!--          <img :src="item.image" :alt="item.title" />-->
<!--        </a>-->
<!--      </main>-->
<!--    </div>-->
    <div class="layout-link">
      <main class="flex flex-row-between items-center">
        <a
            v-for="(item, index) in linkList"
            :key="index"
            :href="item.link"
            target="_blank"
        >
          <img :src="item.image" :alt="item.title" />
        </a>

          <img
              src="../static/images/index/gsgsxywz.png"
              alt="信用网图标"
              style="height: 60px; width: 238px; display: block;"
              @click="dialogVisible = true"
          />

      </main>

      <!-- 弹窗 -->
<!--      <el-dialog-->
<!--          :visible.sync="dialogVisible"-->
<!--          title="信用网站导航"-->
<!--          width="700px"-->
<!--      >-->
<!--        <el-tabs v-model="activeTab">-->
<!--          <el-tab-pane label="各省市信用网" name="province">-->
<!--            <el-row :gutter="10">-->
<!--              <el-col-->
<!--                  v-for="(item, index) in provinceList"-->
<!--                  :key="index"-->
<!--                  :span="8"-->
<!--                  class="link-col"-->
<!--              >-->
<!--                <a :href="item.link" target="_blank" class="link-item">{{ item.name }}</a>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </el-tab-pane>-->

<!--          <el-tab-pane label="市县信用网" name="city">-->
<!--            <el-row :gutter="10">-->
<!--              <el-col-->
<!--                  v-for="(item, index) in cityFlatList"-->
<!--                  :key="index"-->
<!--                  :span="8"-->
<!--                  class="link-col"-->
<!--              >-->
<!--                <a :href="item.link" target="_blank" class="link-item">{{ item.name }}</a>-->
<!--              </el-col>-->
<!--            </el-row>-->
<!--          </el-tab-pane>-->
<!--        </el-tabs>-->
<!--      </el-dialog>-->

      <el-dialog
          :visible.sync="dialogVisible"
          title="信用网站导航"
          width="900px"
      >
        <el-tabs v-model="activeTab">
          <el-tab-pane label="各省市信用网" name="province">
            <el-row :gutter="20">
              <el-col
                  v-for="(item, index) in provinceList"
                  :key="index"
                  :span="8"
                  class="city-col"
              >
                <div class="city-block province-block">
                  <a
                      :href="item.link"
                      target="_blank"
                      class="province-name"
                  >
                    {{ item.name }}
                  </a>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>

          <!-- tab2 -->
          <el-tab-pane label="省内各市县（市、区）" name="city">
            <el-row :gutter="20">
              <el-col
                  v-for="(group, index) in cityList"
                  :key="index"
                  :span="12"
                  class="city-col"
              >
                <div class="city-block">
                  <!-- 城市主链接 -->
                  <a
                      class="city-name"
                      :href="group.cityLink"
                      target="_blank"
                  >
                    {{ group.cityName }}
                  </a>

                  <!-- 区县子链接 -->
                  <template v-for="(child, i) in group.children">
                    <a
                        :key="i"
                        :href="child.link"
                        target="_blank"
                        class="child-link"
                    >
                      {{ child.name }}
                    </a>
                  </template>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>

    </div>

    <div class="layout-bottom">
      <main class="layout-main flex">
        <a
          class="layout-left"
          href="http://121.43.68.40/exposure/jiucuo.html?site_code=3709830030&amp;url=http%3A%2F%2Fwww.feicheng.gov.cn%2F"
        >
          <p class="left-img"></p>
        </a>
        <div class="layout-center">
          <div class="center-top" style="margin-top: 20px">
            <a href="https://beian.miit.gov.cn" target="_blank">
              <span>备案号：</span>
              <span class="">鲁ICP备19062268号-1</span>
            </a>
          </div>
          <div class="about-us flex flex-row-center">
            <router-link tag="span" to="/about">关于我们</router-link><i></i>
            <router-link tag="span" to="/netapplication">网站申明</router-link>
            <div class="visiter-wrap">
              <i class="el-icon-s-data"></i>
              累计访问量&nbsp;:&nbsp;
              <span v-for="(item, index) in browse.toString()" :key="index">{{
                item
              }}</span>
            </div>
          </div>
        </div>
        <a
          class="layout-right"
          href="http://bszs.conac.cn/sitename?method=show&amp;id=0848AD3AD29B758BE053022819AC5DD8"
        >
          <p class="right-img"></p>
        </a>
      </main>
    </div>

    <div
      id="thediv"
      ref="thediv"
      style="
        background: #d11d0f;
        position: absolute;
        z-index: 111;
        left: 0;
        top: 0;
      "
      v-show="theDivShow"
      @mouseover="clearFdAd"
      @mouseout="starFdAd"
    >
      <div
          style="
          position: absolute;
          cursor: pointer;
          font-size: 12px;
          color: #999999;
          right: 0;
        "
          @click="theDivShow = false"
      >
        关闭
      </div>
      <router-link
          to="/repair/country"
          style="
          display: block;
          width: 280px;
          padding: 15px 0;
          height: 160px;
          font-size: 35px;
          text-align: center;
          color: #fff;
          line-height: 65px;
        "
      >
        行政处罚<br />信用修复流程
      </router-link>
    </div>
  </div>
</template>

<script>
import isUndefined from "xe-utils/isUndefined";

import { findTree, mapTree } from "xe-utils";

import { NAVLIST, LINKLIST, TOPLIST } from "@/utils/viewIndex";

import { logout, getFooter, getView } from "@/api";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      // provinceList: [],
      // unitList: [], //成员单位
      // cityList: [],
      search: undefined,
      topList: TOPLIST,
      topId: 1,
      navList: NAVLIST,
      linkList: LINKLIST,
      navName: undefined,
      qrShow: false,
      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 14,
        direction: "horizontal",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
        on: {
          resize: () => {
            this.$refs.swiper.$swiper.changeDirection(
              window.innerWidth <= 960 ? "vertical" : "horizontal"
            );
          },
        },
      },
      bList: [],
      browse: 0,
      // value1: undefined,
      // value2: undefined,
      value3: undefined,
      normalizer(node) {
        return {
          id: node.code,
          label: node.name,
          children: node.children,
        };
      },

      xPos: 0,
      yPos: 0,
      xin: true,
      yin: true,
      step: 1,
      delay: 20,
      height: 0,
      Hoffset: 0,
      Woffset: 0,
      yon: 0,
      xon: 0,
      pause: true,
      theDivShow: true,


      dialogVisible: false,
      activeTab: 'province',
      value1: null,
      value2: null,
      unitList: [],
      provinceList: [
        {name:'信用中国(山东)',link:'https://credit.shandong.gov.cn/'},
        {name:'信用中国(北京)',link:'https://creditbj.jxj.beijing.gov.cn/credit-portal/'},
        {name:'信用中国(上海)',link:'https://credit.fgw.sh.gov.cn/'},
        {name:'信用中国(天津)',link:'https://credit.fzgg.tj.gov.cn/'},
        {name:'信用河北',link:'https://xy.hebei.gov.cn/'},
        {name:'信用中国(山西)',link:'https://creditsx.fgw.shanxi.gov.cn/'},
        {name:'信用中国(辽宁)',link:'https://xyln.ln.gov.cn/credit-portal/'},
        {name:'信用中国(吉林)',link:'http://credit.jl.gov.cn/'},
        {name:'信用中国(黑龙江)',link:'https://credit.hlj.gov.cn/'},
        {name:'信用江苏',link:'https://credit.jiangsu.gov.cn/'},
        {name:'信用中国(浙江)',link:'https://credit.zj.gov.cn/'},
        {name:'信用安徽',link:'https://credit.ah.gov.cn/'},
        {name:'信用中国(福建)',link:'https://xy.fujian.gov.cn/index.html'},
        {name:'信用中国(江西)',link:'https://www.creditjx.gov.cn/'},
        {name:'信用中国(河南)',link:'https://credit.henan.gov.cn/'},
        {name:'信用中国(湖北)',link:'https://credit.hubei.gov.cn/'},
        {name:'信用中国(湖南)',link:'https://credit.fgw.hunan.gov.cn/'},
        {name:'信用中国(四川)',link:'https://credit.sc.gov.cn/'},
        {name:'信用中国(广东)',link:'https://credit.gd.gov.cn/'},
        {name:'信用中国(甘肃)',link:'https://credit.gansu.gov.cn/'},
        {name:'信用中国(海南)',link:'https://xyhn.hainan.gov.cn/CreditHnExtranetWeb/'},
        {name:'信用中国(重庆)',link:'https://www.xycq.gov.cn/'},
        {name:'信用中国(青海)',link:'https://www.qhcredit.gov.cn/'},
        {name:'信用中国(贵州)',link:'https://cx.guizhou.gov.cn/index.html'},
        {name:'信用中国(云南)',link:'https://yncredit.yn.gov.cn/'},
        {name:'信用中国(陕西)',link:'https://credit.shaanxi.gov.cn/'},
        {name:'信用中国(西藏)',link:'https://credit.drc.xizang.gov.cn/'},
        {name:'信用中国(内蒙古)',link:'https://fgw.nmg.gov.cn/xynmg/'},
        {name:'信用中国(广西)',link:'http://xygx.fgw.gxzf.gov.cn/'},
        {name:'信用中国(宁夏)',link:'https://credit.nx.gov.cn/'},
        {name:'信用中国(兵团)',link:'https://credit.xjbt.gov.cn/'},
        {name:'信用中国(新疆)',link:'https://www.creditxj.gov.cn/'},


      ],

       cityList: [
        {
          cityName: '济南市',
          cityLink: 'https://jncredit.jinan.gov.cn/',
          children: []
        },
        {
          cityName: '青岛市',
          cityLink: 'http://www.qingdao.gov.cn/credit/index.shtml',
          children: [
            { name: '胶州市', link: 'http://120.221.95.100/credit/' },
            { name: '平度市', link: 'http://credit.pingdu.gov.cn/' },
            { name: '莱西市', link: 'http://www.laixi.gov.cn/cms-web/' },
            { name: '青岛自贸片区', link: 'http://credit.eyunhan.com/' }
          ]
        },
        {
          cityName: '淄博市',
          cityLink: 'https://credit.zibo.gov.cn/home/home.html',
          children: []
        },
        {
          cityName: '枣庄市',
          cityLink: 'http://credit.zaozhuang.gov.cn/',
          children: [
            { name: '滕州市', link: 'http://credit.tengzhou.gov.cn/' },
            { name: '薛城区', link: 'https://xccredit.cn/' }
          ]
        },
        {
          cityName: '东营市',
          cityLink: 'http://credit.dongying.gov.cn/',
          children: []
        },
        {
          cityName: '烟台市',
          cityLink: 'https://credit.yantai.gov.cn/',
          children: [
            { name: '龙口市', link: 'https://www.lkcredit.cn/' },
            { name: '莱阳市', link: 'https://www.laiyang.gov.cn/lycredit/' },
            { name: '招远市', link: 'https://www.zycredit.cn/' }
          ]
        },
        {
          cityName: '潍坊市',
          cityLink: 'http://credit.weifang.gov.cn/',
          children: [
            { name: '诸城市', link: 'http://www.zhucheng.gov.cn/credit/' },
            { name: '青州市', link: 'http://www.qingzhou.gov.cn/qzxy/' }
          ]
        },
        {
          cityName: '济宁市',
          cityLink: 'https://credit.jining.gov.cn/home',
          children: []
        },
        {
          cityName: '泰安市',
          cityLink: 'http://credit.taian.gov.cn/',
          children: [
            { name: '泰山区', link: 'http://credit.sdtaishan.gov.cn/' },
            { name: '岱岳区', link: 'http://www.xinyongdaiyue.com/' },
            { name: '新泰市', link: 'http://www.xintai.gov.cn/xtcredit/' },
            { name: '肥城市', link: 'http://www.feicheng.gov.cn/col/col164743/index.html' },
            { name: '东平县', link: 'http://120.224.9.60:5050/' },
            { name: '宁阳县', link: 'http://credit.ny.gov.cn/' }
          ]
        },
        {
          cityName: '威海市',
          cityLink: 'https://credit.weihai.gov.cn/home/home.html',
          children: [
            { name: '环翠区', link: 'http://credit.weihaihuancui.cn/home/home.html' },
            { name: '文登区', link: 'http://wdcredit.weihai.cn/' },
            { name: '荣成市', link: 'https://www.rccredit.cn/' },
            { name: '乳山市', link: 'https://rscredit.weihai.cn/' }
          ]
        },
        {
          cityName: '日照市',
          cityLink: 'http://credit.rizhao.gov.cn/home/home.html',
          children: [
            { name: '五莲县', link: 'http://xywl.sdzxkj.cn/' },
            { name: '莒县', link: 'http://credit.rizhao.gov.cn/jx/' }
          ]
        },
        {
          cityName: '临沂市',
          cityLink: 'https://creditly.linyi.gov.cn/',
          children: []
        },
        {
          cityName: '德州市',
          cityLink: 'https://credit.dezhou.gov.cn/dz/',
          children: []
        },
        {
          cityName: '聊城市',
          cityLink: 'http://credit.liaocheng.gov.cn/home/home.html',
          children: [
            { name: '东昌府区', link: 'https://www.xinyidcf.cn/' },
            { name: '临清市', link: 'http://www.linqing.gov.cn/xylq/' },
            { name: '冠县', link: 'https://www.gxcredit.cn/' }

          ]
        },
        {
          cityName: '滨州市',
          cityLink: 'https://credit.binzhou.gov.cn/home/home.html',
          children: [
            { name: '沾化区', link: 'https://credit.binzhou.gov.cn/zhcredit/home/' },
            { name: '博兴县', link: 'https://credit.binzhou.gov.cn/bxcredit/home/home.html' },
            { name: '邹平市', link: 'https://credit.binzhou.gov.cn/zpcredit/home/home.html' }
          ]
        },
        {
          cityName: '菏泽市',
          cityLink: 'http://credit.heze.gov.cn/',
          children: []
        }
      ]

      // cityList: [
      //   {
      //     name: '山东省',
      //     id: '370000',
      //     children: [
      //       {name:'济南市',link:'https://jncredit.jinan.gov.cn/'},
      //       {name:'青岛市',link:'http://www.qingdao.gov.cn/credit/index.shtml'},
      //       {name:'淄博市',link:'https://credit.zibo.gov.cn/home/home.html'},
      //       {name:'枣庄市',link:'http://credit.zaozhuang.gov.cn/'},
      //       {name:'东营市',link:'http://credit.dongying.gov.cn/'},
      //       {name:'烟台市',link:'https://credit.yantai.gov.cn/'},
      //       {name:'烟台(龙口市)',link:'https://www.lkcredit.cn/'},
      //       {name:'烟台(莱阳市)',link:'https://www.laiyang.gov.cn/lycredit/'},
      //       {name:'烟台(招远市)',link:'https://www.zycredit.cn/'},
      //       {name:'潍坊市',link:'http://credit.weifang.gov.cn/'},
      //       {name:'潍坊(诸城市)',link:'http://www.zhucheng.gov.cn/credit/'},
      //       {name:'潍坊(青州市)',link:'http://www.qingzhou.gov.cn/qzxy/'},
      //       {name:'济宁市',link:'https://credit.jining.gov.cn/home'},
      //       {name:'泰安市',link:'http://credit.taian.gov.cn/'},
      //       {name:'泰安(泰山区)',link:'http://credit.sdtaishan.gov.cn/'},
      //       {name:'泰安(岱岳区)',link:'http://www.xinyongdaiyue.com/'},
      //       {name:'泰安(新泰市)',link:'http://www.xintai.gov.cn/xtcredit/'},
      //       {name:'泰安(肥城市)',link:'http://www.feicheng.gov.cn/'},
      //       {name:'泰安(东平县)',link:'http://120.224.9.60:5050/'},
      //       {name:'泰安(宁阳县)',link:'http://credit.ny.gov.cn/'},
      //       {name:'威海市',link:'https://credit.weihai.gov.cn/home/home.html'},
      //       {name:'威海(荣成市)',link:'https://www.rccredit.cn/'},
      //       {name:'日照市',link:'http://credit.rizhao.gov.cn/home/home.html'},
      //       {name:'临沂市',link:'https://creditly.linyi.gov.cn/'},
      //       {name:'德州市',link:'https://credit.dezhou.gov.cn/dz/'},
      //       {name:'聊城市',link:'http://credit.liaocheng.gov.cn/home/home.html'},
      //       {name:'滨州市',link:'https://credit.binzhou.gov.cn/home/home.html'},
      //       {name:'菏泽市',link:'http://credit.heze.gov.cn/'},
      //
      //     ]
      //   }
      // ],


    };
  },
  created() {},
  mounted() {
    const { name } = this.$route;
    this.$set(this, "navName", name);
    if (name === "article") {
      const {
        params: { from },
      } = this.$route;
      let navName = undefined;
      switch (+from) {
        case 1:
          navName = "dynamic";
          break;
        case 2:
          navName = "industries";
          break;
        case 3:
          navName = "typical";
          break;
        case 4:
          navName = "policy";
          break;
        case 5:
          navName = "research";
          break;
        case 6:
          navName = "special";
          break;
        case 7:
          navName = "risks";
          break;
        case 8:
          navName = "rewardsPunishments";
          break;
        default:
          break;
      }
      if (navName) {
        this.$set(this, "navName", navName);
      }
    }
    this.getFooterLink();
    this.getCommonLinks();

    if (name === "index") {
      this.$refs.thediv.style.visibility = "visible";

      this.interval = setInterval(this.changePos, this.delay);
    } else {
      this.clearFdAd();
      this.$refs.thediv.style.visibility = "hidden";
    }
  },

  beforeCreate() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },

  methods: {
    changePos() {
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      this.$nextTick(() => {
        const refDom = this.$refs.thediv;
        if (refDom) {
          this.Hoffset = refDom.offsetHeight; //获取元素高度
          this.Woffset = refDom.offsetWidth;
        }
      });

      // 滚动部分跟随屏幕滚动
      // this.$refs.thediv.style.left = (this.xPos + document.body.scrollLeft + document.documentElement.scrollLeft) + "px";
      // this.$refs.thediv.style.top = (this.yPos + document.body.scrollTop + document.documentElement.scrollTop) + "px";

      // 滚动部分不随屏幕滚动
      this.$refs.thediv.style.left =
        this.xPos + document.body.scrollLeft + "px";
      this.$refs.thediv.style.top = this.yPos + document.body.scrollTop + "px";

      if (this.yon) {
        this.yPos = this.yPos + this.step;
      } else {
        this.yPos = this.yPos - this.step;
      }
      if (this.yPos < 0) {
        this.yon = 1;
        this.yPos = 0;
      }
      if (this.yPos >= height - this.Hoffset) {
        this.yon = 0;
        this.yPos = height - this.Hoffset;
      }

      if (this.xon) {
        this.xPos = this.xPos + this.step;
      } else {
        this.xPos = this.xPos - this.step;
      }
      if (this.xPos < 0) {
        this.xon = 1;
        this.xPos = 0;
      }
      if (this.xPos >= width - this.Woffset) {
        this.xon = 0;
        this.xPos = width - this.Woffset;
      }
    },
    clearFdAd() {
      clearInterval(this.interval);
    },
    starFdAd() {
      this.interval = setInterval(this.changePos, this.delay);
    },

    topNavChange(row) {
      const { id } = row;
      if (this.topId !== id) {
        this.$set(this, "topId", id);
        this.$set(this, "search", undefined);
      }
    },
    searchHandler() {
      if (isUndefined(this.search)) {
        return;
      }
      let routerName;
      if (this.topId === 3) {
        routerName = "searchArticle";
      } else {
        routerName = "searchCompanyList";
      }
      this.$router.push({
        name: routerName,
        query: {
          type: this.topId,
          keywords: this.search,
        },
      });
    },
    goUserCallback() {
      if (this.$store.state.token) {
        this.$router.push("/userFeedback");
      } else {
        this.$router.push("/login");
      }
    },
    prev() {
      this.$refs.swiper.$swiper.slidePrev();
    },
    next() {
      this.$refs.swiper.$swiper.slideNext();
    },
    logoutHandler() {
      logout().then((res) => {
        this.$store.dispatch("setToken", undefined);
        this.$store.dispatch("setUserInfo", {});
        this.$router.replace("/");
      });
    },

    getCommonLinks() {
      getView().then((res) => {
        this.$set(this, "browse", res || 0);
      });
    },

    // urlBlank(val, type) {
    //   if (type === 3) {
    //     const length = val.length;
    //     const lastId = val[length - 1];
    //     const city = findTree(this.cityList, (item) => item.id === lastId);
    //     if (city.item) {
    //       const {
    //         item: { link },
    //       } = city;
    //       if (link) {
    //         window.open(link, "_blank");
    //       }
    //     }
    //   } else {
    //     if (val) {
    //       const row = [this.unitList, this.provinceList, this.cityList][
    //         type - 1
    //       ].find((item) => item.code === val);
    //       window.open(row.link, "_blank");
    //     }
    //   }
    // },
    getFooterLink() {
      getFooter().then((res) => {
        const {
          cityCountyCreditLinks,
          memberUnitLinks,
          footerLinks,
        } = res;
        this.$set(this, "bList", footerLinks || []);
        this.$set(this, "unitList", memberUnitLinks || []);
        // this.$set(this, "provinceList", otherProvinceCityCreditLinks || []);
        // this.$set(
        //   this,
        //   "cityList",
        //   mapTree(cityCountyCreditLinks || [], (item) => {
        //     const children = item.children;
        //     if (children.length > 0) {
        //       return item;
        //     } else {
        //       const { children, ...last } = item;
        //       delete item.children;
        //       return item;
        //     }
        //   })
        // );
      });
    },
    // urlBlank(val, type) {
    //   let list = []
    //   if (type === 1) list = this.unitList
    //   if (type === 2) list = this.provinceList
    //   if (type === 3) {
    //     const target = this.cityList
    //         .flatMap(p => p.children || [])
    //         .find(i => i.id === val?.[1])
    //     if (target?.link) window.open(target.link)
    //     return
    //   }
    //   const item = list.find(i => i.code === val)
    //   if (item?.link) window.open(item.link)
    // }
    urlBlank(val, type) {
      let list = []
      if (type === 1) list = this.unitList
      if (type === 2) list = this.provinceList
      if (type === 3) {
        const target = this.cityList
            .flatMap(p => p.children || [])
            .find(i => i.id === val?.[1])
        if (target?.link) window.open(target.link)
        return
      }
      const item = list.find(i => i.code === val)
      if (item?.link) window.open(item.link)
    }
  },
  computed: {
    placeholder() {
      return this.topList.find((item) => item.id === this.topId).placeholder;
    },
    userInfo({ $store }) {
      const {
        state: { userInfo },
      } = $store;
      return userInfo || {};
    },
    nickName() {
      return this.userInfo.mobile;
    },
    cityFlatList() {
      return this.cityList.flatMap(p => (p.children || []).filter(c => c.link))
    }
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        const { name } = val;
        if (name === "article") {
          const {
            params: { from },
          } = val;
          let navName = undefined;
          switch (+from) {
            case 1:
              navName = "dynamic";
              break;
            case 2:
              navName = "industries";
              break;
            case 3:
              navName = "typical";
              break;
            case 4:
              navName = "policy";
              break;
            case 5:
              navName = "research";
              break;
            case 6:
              navName = "special";
              break;
            case 7:
              navName = "risks";
              break;
            case 8:
              navName = "rewardsPunishments";
              break;
            default:
              break;
          }
          if (navName) {
            this.$set(this, "navName", navName);
          }
        } else {
          this.$set(this, "navName", name);
        }

        if (name === "index") {
          this.$refs.thediv.style.visibility = "visible";

          this.interval = setInterval(this.changePos, this.delay);
        } else {
          this.$refs.thediv.style.visibility = "hidden";

          this.clearFdAd();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang='scss' >
$red: #d01c0b;

.link-col {
  /* 列间距已由 el-row 的 gutter 控制，一般不必额外设置 */
}

//.link-item {
//  display: block;          /* 块级元素撑满列宽 */
//  word-break: break-word;  /* 文字超长自动换行 */
//  color: #409EFF;          /* 你可以按需调整颜色 */
//  text-decoration: none;
//  padding: 4px 8px;        /* 增加点击区域 */
//}
//
//.link-item:hover {
//  text-decoration: underline;
//  color: #66b1ff;
//}

.city-col {
  box-sizing: border-box;
}

//.city-block {
//  border: 1px solid #dcdfe6;
//  border-radius: 4px;
//  padding: 8px 12px;
//  background-color: #fff;
//  display: flex;
//  flex-wrap: wrap;
//  align-items: center;
//}
//
//.city-col {
//
//}

.city-col {
  box-sizing: border-box;
  margin-bottom: 16px;
}

.city-block {
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  padding: 12px 16px;
  background-color: #f5f7fa;
  display: flex;
  flex-wrap: wrap;
  align-items: center;       /* 垂直居中 */
  justify-content: flex-start; /* 水平左对齐 */
  min-height: 60px;
}

.province-block {
  justify-content: center;
}

.province-name {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
  text-decoration: none;
}

.province-name:hover {
  color: #409EFF;
  text-decoration: underline;
}

.city-name {
  font-weight: bold;
  color: #303133;
  margin-right: 8px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.city-name:hover {
  color: #409EFF;
  text-decoration: underline;
}

.child-link {
  color: #409EFF;
  font-size: 14px;
  margin-right: 8px;
  margin-bottom: 0px;
  text-decoration: none;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
}

.child-link:hover {
  text-decoration: underline;
}
main {
  width: 1280px;
  margin: 0 auto;
}

.el-backtop {
  width: 99px;
  height: 110px;
  border-radius: 0;
  background-color: rgba(250, 250, 250, 0.8);
  border: 1px solid #e3e8e0;
  border-top: none;
  box-shadow: none;

  p {
    line-height: 1;
    font-size: 16px;
    color: #212121;
    margin-top: 15px;
  }
}

.layout-wrap {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;

  .layout-fixed {
    position: fixed;
    bottom: 150px;
    right: 0;
    & > .flex-wechat {
      min-height: 110px;
      & > div {
        height: 110px;
      }
    }
    & > div {
      width: 100px;
      min-height: 110px;
      border-radius: 0;
      background-color: rgba(250, 250, 250, 0.8);
      border: 1px solid #e3e8e0;
      cursor: pointer;

      &:hover {
        background-color: #f2f6fc;
      }

      p {
        line-height: 1;
        font-size: 16px;
        color: #212121;
        margin-top: 15px;
      }

      .qr-wrap {
        padding: 10px;

        img {
          width: 100%;
          height: 100%;
        }

        p {
          font-size: 12px;
          text-align: center;
          color: rgb(33, 33, 33);
          margin-top: 5px;
        }
      }
    }
  }

  .layout-top {
    width: 100%;
    height: 300px;
    line-height: 40px;
    margin: 0 auto;
    text-align: right;
    color: #d01c0b;
    background-image: url("../static/images/top-bg.png");
    background-size: 100% 100%;
    font-size: 16px;
    main {
      position: relative;
      height: 300px;

      .logo-wrap {
        position: absolute;
        left: 0;
        top: 13%;
      }

      .user-wrap {
        position: absolute;
        margin-top: 55px;
        right: 0;
        letter-spacing: 0;
        cursor: pointer;
        a {
          color: $red;
        }
      }

      .search-wrap {
        position: absolute;
        top: 55px;
        left: 50%;
        margin-left: -138px;
        height: 200px;

        .search-nav {
          & > li {
            margin-right: 60px;
            cursor: pointer;
            color: #4c4e4d;
            font-weight: 700;
            margin-bottom: 20px;
            line-height: 30px;
            &.active {
              color: $red;
              position: relative;

              &::after {
                content: "";
                position: absolute;
                width: 0;
                height: 0;
                top: 42px;
                left: 50%;
                transform: translate(-50%, 0);
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 8px solid $red;
                z-index: 10;
              }
            }
          }
        }
      }
    }
  }

  .layout-nav {
    width: 100%;
    background-color: $red;
    .nav-link {
      width: 155px;
      line-height: 40px;
      font-size: 18px;
      color: #fff;
      margin: 0 23px;
      padding: 5px 0;
      position: relative;
      text-align: center;
      &:not(:nth-child(6n)) {
        &::after {
          content: "";
          display: block;
          position: absolute;
          border-left: 1px solid #eb6100;
          height: 20px;
          right: -24px;
          top: 10px;
        }
      }
      &:not(:nth-child(n + 7)) {
        border-bottom: 1px solid #eb6100;
      }
      &.active {
        p {
          background-color: #ab0300;
          font-weight: 600;
          // line-height: 30px;
          // margin: 5px 0;
        }
      }
    }
  }

  .layout-gov {
    width: 100%;
    // height: 200px;
    padding: 28px 0;
    background-color: #e7e7e7;
    .swiper-wrap {
      width: 100%;
      position: relative;
      .swiper-button-next {
        right: calc(50% - 680px);
      }
      .swiper-button-prev {
        left: calc(50% - 680px);
      }
      .swiper-button-next,
      .swiper-button-prev {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #aaa;
        color: #fff;
        // transform: translate(0, -50%);
        &::after {
          font-size: 14px;
        }
      }
    }
    .swiper {
      margin: 0 auto;
      width: 1280px;
    }
    & .gov-list {
      flex-shrink: 0;
      // width: 244.8px;
      width: 100%;
      margin-right: 14px;
      height: 75px;
      padding: 0 10px 0 0;
      text-align: center;
      font-weight: 700;
      color: #797979;
      border: 1px solid #c2c2c2;
      background-color: #fff;
      & > img {
        width: 48px;
        height: 48px;
        margin: 0 16px;
      }
      & > p {
        // width: calc(100% - 80px);
        width: 100%;
      }
    }
  }

  .layout-link {
    padding: 15px 0;
    main {
      & > div,
      & > a {
        width: auto;
        height: 60px;
        border: 1px solid #e5e5e5;
      }
      & > a {
        overflow: hidden;
        & > img {
          width: 100%;
          object-fit: fill;
          height: 60px;
        }
      }

      & > div {
        padding-top: 5px;
        .el-select,
        .el-cascader {
          width: 100%;
          & > .el-input {
            width: 100%;
            color: #373c43;
            font-size: 14px;
            & > .el-input__inner {
              border: none;
            }
          }
        }
        input::-webkit-input-placeholder {
          color: #373c43;
        }
        input::-moz-input-placeholder {
          color: #373c43;
        }
        input::-ms-input-placeholder {
          color: #373c43;
        }
      }
    }
  }

  .layout-router {
    background-color: #fbfbfb;
  }

  .layout-bottom {
    width: 100%;
    background-color: $red;
    height: 150px;

    .layout-main {
      height: 100%;
      overflow: hidden;
      color: #fff;
      padding: 25px 0 33px 300px;

      .layout-left {
        width: 80px;
        height: 80px;
        margin: 4px 40px 0 0;
        float: left;
        background: url("../static/images/bottom-left.png") no-repeat 50%;
      }

      .layout-center {
        width: 50%;
        & > .center-top {
          font-size: 16px;
          margin-bottom: 5px;
          text-align: center;
          a {
            color: #fff;
          }
        }
        & > .about-us {
          cursor: pointer;
          & > i {
            display: inline-block;
            vertical-align: middle;
            width: 1px;
            height: 15px;
            background: #fff;
            margin: 0 10px;
          }
          & > .visiter-wrap {
            margin-left: 35px;
            & > span {
              margin-right: 3px;
              padding: 0 4px;
              border: 1px solid #fff;
              line-height: 20px;
              vertical-align: baseline;
              border-radius: 4px;
            }
          }
        }
      }
      .layout-right {
        width: 110px;
        height: 55px;
        margin-top: 15px;
        float: left;
        background: url("../static/images/bottom-right.png") no-repeat 50%;
      }
    }
  }
}
</style>
